import React from "react";
import { SampleRequestDetailPage } from "../../SharedPages/SampleRequestDetailPage/SampleRequestDetailPage";

export const BuyerSampleRequestDetail = () => {
  return <SampleRequestDetailPage />;
};
